import Chart from '../../common/chart/index';

function getColor(active) {
  return active ? '#ffc734' : '#575757';
}

const StockItPerformance = ({charts}) =>
  (
    <div className="container-fluid">
      {
        charts.map((chart, key) => (
          chart && (
          <Chart
            key={key}
            name={chart.name}
            data={chart.data}
            barValueKeys={[{
              key: 'value',
              color: getColor(chart.active)
            }]}
            refLines={chart.trend_lines}
            yLeftLabel={'No of products'}
            leftTicks={[0, chart.y_axis_max]}
            refLineColor={chart.active ? '#ab1738' : '#959595'}
            active={chart.active}
            showTooltip
          />
        )))
      }
    </div>
  );

export default StockItPerformance;
